import React, { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component {
  render() {
    const { title, parent } = this.props;
    return (
      <React.Fragment>
        <div
          className="rn-page-title-area pt--80 pb--80 bg_image bg_image--header"
          data-black-overlay="6"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner pt--100">
                  <h2 className="title">{title}</h2>
                  <ul className="page-list">
                    <li className="rn-breadcrumb-item">
                      <Link to={`${process.env.PUBLIC_URL}`}>Home</Link>
                    </li>
                    {parent ? (
                      <li className="rn-breadcrumb-item">{parent}</li>
                    ) : (
                      ""
                    )}
                    <li className="rn-breadcrumb-item active">{title}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Breadcrumb;
